<template>
  <div style="padding: 10px 15px;" v-if="story.pinnedPost != undefined" class="story-header">
    <ion-icon style="color: rgba(var(--dashboard-contrast-color-rgb), 1.0); margin-right: 5px;"
      src="/assets/push-pin.svg"></ion-icon>
    <div style="margin-top: -3px; font-weight: bold; color: rgba(var(--dashboard-contrast-color-rgb), 1.0);"
      v-if="story.pinnedPost != undefined">Pinned Post</div>
  </div>
  <div class="story-header">
    <div class="story-header-pic" v-if="repost == true">
      <img style="width:30px; height:30px;" piklist-user-id="{{piklist_user_id}}"
        v-if="originator_profile_pic == '' || originator_profile_pic == undefined" src="/assets/spyguy.png"
        v-on:click="goToProfile(originator_id)">
      <img style="width:30px; height:30px;" @error="imgUrlAlt" piklist-user-id="{{piklist_user_id}}"
        v-if="originator_profile_pic != '' && originator_profile_pic != undefined"
        :src="path + '/profile/' + originator_profile_pic" v-on:click="goToProfile(originator_id)">
    </div>
    <div class="story-header-pic" v-else>
      <div v-if="story.groupInfo.id != undefined">
        <img piklist-user-id="{{story.groupInfo.id}}"
          v-if="story.groupInfo.profile_image == '' || story.groupInfo.profile_image == undefined"
          src="/assets/spyguy.png" v-on:click="goToGroup(story.groupInfo.id)">
        <img @error="imgUrlAlt" piklist-user-id="{{story.groupInfo.id}}" v-else
          :src="path + '/profile/' + story.groupInfo.profile_image" v-on:click="goToGroup(story.groupInfo.id)">
      </div>
      <div v-else>
        <img piklist-user-id="{{piklist_user_id}}" v-if="piklist_profile_pic == '' || piklist_profile_pic == undefined"
          src="/assets/spyguy.png" v-on:click="goToProfile(user_id)">
        <img @error="imgUrlAlt" piklist-user-id="{{piklist_user_id}}"
          v-if="piklist_profile_pic != '' && piklist_profile_pic != undefined"
          :src="path + '/profile/' + piklist_profile_pic" v-on:click="goToProfile(user_id)">
      </div>
    </div>
    <div class="story-header-content">
      <div class="story-header-post" v-show="pikd_pik_id == 0 || pikd_pik_id == null">
        <div v-if="story.groupInfo.id != undefined">
          <span class="full-name-header"><span style="margin-right:5px;" v-on:click="goToGroup(story.groupInfo.id)">{{ story.groupInfo.name }}</span>
            <UserBadges :ecb="story.groupInfo.ecb" :certified="story.groupInfo.certified" /> 
            <div v-on:click="goToProfile(user_id)" class="user-name-header">
              <span v-html="showAddedBy(user_name)"></span> &middot;
              {{ getUploadDate(localDate(), this.$root.$i18n.locale) }}
              &middot;
              <ion-icon style="font-size: 0.8em;" :icon="showVisibility(visibility)"></ion-icon> {{ post_address }}
            </div>
          </span>
        </div>
        <div v-else>
          <span class="full-name-header"><span v-on:click="goToProfile(user_id)" style="cursor: pointer; margin-right:5px;">{{ piklist_fullname }}</span>
            <UserBadges :ecb="piklist_ecbbadge" :certified="piklist_userbadge" /> 
            <span v-on:click="goToProfile(user_id)" style="font-weight: normal; color: rgba(var(--dashboard-contrast-color-rgb), 1.0);">@{{ piklist_username
  }}</span>
            <div class="user-name-header"> <span v-if="live_video && type==2">Was live</span> <span v-if="live_video && type==4">Is LIVE </span>
              <span v-if="premiere_date!=undefined && premiere_date != ''">
                <span v-if="dayjs(premiere_date).isAfter(dayjs())">PREMIERES {{ premiereTime }}</span>
                <span v-else>PREMIERED {{ getUploadDate(localDate(), this.$root.$i18n.locale) }}</span>
              </span>
              <span v-else>{{ getUploadDate(localDate(), this.$root.$i18n.locale) }}</span>
              &middot;
              <ion-icon style="font-size: 0.8em;" :icon="showVisibility(visibility)"></ion-icon> {{ post_address }}
              <span v-if="user_id != null && user_id != piklist_user_id" v-on:click="goToProfile(user_id)">
                <span v-html="showAddedBy(user_name)"></span>
              </span>
            </div>
          </span>
        </div>
      </div>
      <div class="story-header-repost" v-show="pikd_pik_id != 0 && pikd_pik_id != null && repost == false">
        <div v-if="story.groupInfo.id != undefined">
          <span class="full-name-header"><span style="margin-right:5px;" v-on:click="goToGroup(story.groupInfo.id)">{{ story.groupInfo.name }}</span>
            <UserBadges :ecb="story.groupInfo.ecb" :certified="story.groupInfo.certified" />
            <div v-on:click="goToProfile(user_id)" class="user-name-header">
              <span v-html="showAddedBy(user_name)"></span>
            </div>
          </span>
        </div>
        <div v-else>
          <span style="margin-right:5px;" v-on:click="goToProfile(user_id)" class="full-name-header">{{ piklist_fullname }}</span>
            <UserBadges :ecb="piklist_ecbbadge" :certified="piklist_userbadge" />
            <span v-on:click="goToProfile(user_id)" class="user-name-header" style="color: rgba(var(--dashboard-contrast-color-rgb), 1.0);">@{{
    piklist_username }}</span>
          
        </div>
        <div class="original-user-name">
          <span class="normal-text">{{ $t("buttons.from") }}&nbsp;</span>
          <span class="original-photo-text" v-on:click="goToStory(pikd_pik_id)">{{ $t("buttons.story") }}&nbsp;</span>
          <span v-show="originator_id != user_id" class="normal-text">{{ $t("buttons.by") }}&nbsp;</span>
          <span v-show="originator_id != user_id" class="originator" originator-id="{{originator_id}}"
            v-on:click="goToProfile(originator_id)">{{ originator_username }}</span>
          <span style="margin-left:5px;" class="user-name-header">
            {{ getUploadDate(localDate(), this.$root.$i18n.locale) }}&middot;
            <ion-icon style="font-size: 0.8em;" :icon="showVisibility(visibility)"></ion-icon> {{ story.post_address }}
          </span>
        </div>
      </div>
      <div class="story-header-post" v-on:click="goToProfile(originator_id)" style="cursor: pointer;"
        v-show="pikd_pik_id != 0 && pikd_pik_id != null && repost == true">
        <div class="full-name-header">{{ originator_fullname }}
          <UserBadges :certified="originator_userbadge" />
          <span class="user-name-header">@{{ repost_username }}</span>
        </div>
      </div>
      <div class="story-header-repost" v-show="user_id != piklist_user_id">
      </div>
    </div>
    <div v-if="isAd == '' || (myProfileId == user_id)"
      v-show="(pikd_pik_id != 0 && pikd_pik_id != null && repost == false) || (pikd_pik_id == 0 || pikd_pik_id == null)"
      @click="openPopover($event, story)" style="cursor: pointer;" class="story-options">
      <ion-icon id="options" style="font-size:18px; float:right;" :icon="chevronDown"></ion-icon>
    </div>
    <div class="story-upload-time" v-if="isAd == 'Y' && (myProfileId != user_id)">
      {{ $t("buttons.ad") }}
    </div>
  </div>
  <div class="story-name-block" v-show="piklist_name != ''">
    <div class="story-name" v-html="piklist_name"></div>
  </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from "vue";
import { modalController, popoverController, alertController, IonIcon, loadingController } from '@ionic/vue';
import { globeOutline, people, bookmarks, chevronDown, location } from 'ionicons/icons';
import { getUploadDate } from '@/composables/date';

import getEnv from '@/utils/env';

const EditPostModal = defineAsyncComponent(() =>
  import('@/components/posts/EditPost.vue'))

const EditPrivacyModal = defineAsyncComponent(() =>
  import('@/components/ChooseFriendsModal.vue'))

const EditStoryNameModal = defineAsyncComponent(() =>
  import('@/components/posts/EditStoryName.vue'))

const ReportPostModal = defineAsyncComponent(() =>
  import('@/components/posts/ReportPost.vue'))

const HidePostModal = defineAsyncComponent(() =>
  import('@/components/posts/HidePost.vue'))

const Popover = defineAsyncComponent(() =>
  import('@/components/Popover.vue'))

const UserBadges = defineAsyncComponent(() =>
  import('@/components/UserBadges.vue'))

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default defineComponent({
  name: "PostHeader",
  emits: ['update:description', 'update:visibility', 'update:piklist_name'],
  props: {
    story: { Object, default: null },
    myProfileId: { Object, default: null },
    slider: { Number, default: 0 },
    description: { String, default: '' },
    piklistId: { Number, default: 0 },
    imageId: { Number, default: 0 },
    piklist_user_id: { Number, default: 0 },
    storefront: { Object, default: 0 },
    piklist_profile_pic: { String, default: '' },
    user_id: { Number, default: 0 },
    user_name: { String, default: '' },
    pikd_pik_id: { Number, default: 0 },
    piklist_fullname: { String, default: '' },
    piklist_userbadge: { Number, default: 0 },
    piklist_ecbbadge: { Number, default: 0 },
    piklist_username: { String, default: '' },
    originator_id: { Number, default: 0 },
    originator_username: { String, default: '' },
    isAd: { Number, default: 0 },
    date_time: { String, default: '' },
    visibility: { Number, default: 0 },
    piklist_name: { String, default: '' },
    repost: { Boolean, default: false },
    post_address: { String, default: '' },
    live_video: { Boolean, default: false },
    type: { String, default: '' },
    premiere_date: { String, default: '' },
  },
  setup() {
    return {
      chevronDown,
      getEnv,
      getUploadDate,
      location,
      dayjs
    }
  },
  components: {
    IonIcon,
    UserBadges
  },
  data() {
    return {
      path: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET'),
      originator_fullname: '',
      originator_profile_pic: '',
      originator_userbadge: '',
      origin_date: '',
      repost_username: '',
    }
  },
  methods: {
    async goToProfile(id) {
      this.$router.push({ name: 'profile', params: { id: id } });
    },
    async goToGroup(id) {
      this.$router.push({ name: 'groupview', params: { id: id } });
    },
    goToStory(id) {
      this.$router.push({ name: 'story', params: { imageid: id } });

    },
    async openPopover(ev, story) {
      //console.log(story);
      //console.log(this.user_id, 'user id');
      if (this.$store.state.auth.token != '') {
        if (story.isPremium == 'yes' && story.canViewPremium == 'no') {
          return;
        }

        var type = 'public-story';

        if (this.myProfileId == this.user_id || this.myProfileId == this.piklist_user_id) {
          type = 'owner-story';
        }

        // if this is not your post and it's in a group, permissions need to be checked
        if (story.groupInfo['id'] != undefined) {
          if (this.myProfileId == this.user_id) {
            if (story.groupInfo['isAdmin']) {
              type = 'group-story-admin-owner';
            } else {
              type = 'group-story-owner';
            }
          } else if (this.myProfileId != this.user_id && story.groupInfo['isAdmin']) {
            type = 'group-story-admin-other';
          }
        }
        const popover = await popoverController
          .create({
            component: Popover,
            cssClass: 'my-custom-class',
            event: ev,
            translucent: true,
            componentProps: {
              name: this.$t("popover.storyoptions"),
              type: type,
              data: story
            }
          })
        await popover.present();

        const { role } = await popover.onDidDismiss();
        if (role == "edit-post") {
          this.openEditPostModal();
        } else if (role == "delete-post") {
          // alert prompt
          this.presentAlert('post', '');
        } else if (role == "edit-storyname") {
          this.openEditStoryNameModal(story);
        } else if (role == "edit-privacy") {
          this.openEditPrivacyModal(story);
        } else if (role == "edit-canadd") {
          this.openEditCanAddModal(story);
        } else if (role == "report-post") {
          this.openReportPostModal();
        } else if (role == "hide-post") {
          this.openHidePostModal();
        } else if (role == "request-add") {
          this.presentAlert('add', '');
        } else if (role == "pin-post") {
          if (story.pinnedPost) {
            //console.log(story.pinnedPost, 'post id');
            this.presentAlert('unpin', story.pinnedPost);
          } else {
            this.presentAlert('pin', this.imageId);
          }
        }
        //console.log('onDidDismiss resolved with role', role);
      } else {
        this.presentLoginAlertConfirm();
      }
    },
    async openEditPostModal() {
      // calculate post id here
      console.log(this.premiere_date, 'premiere date');
      const modal = await modalController
        .create({
          component: EditPostModal,
          cssClass: this.premiere_date && this.premiere_date !== '' ? 'editpost-premiere-custom-class' : 'editpost-custom-class',
          componentProps: {
            title: this.$t("popover.editpost"),
            piklistId: this.piklistId,
            imageId: this.imageId,
            description: this.description,
            premiere_date: this.premiere_date
          }
        })
      await modal.present();
      const dismissed = await modal.onDidDismiss();
      if (dismissed.role != 'canceled') {
        //console.log(this.$store.state.postedit.caption, 'caption update');
        this.$emit('update:description', this.$store.state.postedit.caption);
        this.$store.commit('postedit/setCaption', '');
        this.completedPost('caption', this.imageId);
      }

    },
    async presentAlert(type, id) {
      var message = '';
      var header = '';
      var buttonName = '';
      if (type == "post") {
        header = this.$t("alerthead.postdelete");
        message = this.$t("alertmessage.postdelete");
        buttonName = this.$t("alertbutton.postdelete");
      } else if (type == "add") {
        header = this.$t("alerthead.addtopost");
        message = this.$t("alertmessage.addtopost");
        buttonName = this.$t("alertbutton.addtopost");
      } else if (type == "pin") {
        header = 'Pin Post';
        message = 'Do you want to pin this post to the top of the profile?';
        buttonName = 'Pin It';
      } else if (type == "unpin") {
        header = 'Unpin Post';
        message = 'Are you sure you want to unpin this post from the top of the profile?';
        buttonName = 'Unpin It';
      }

      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: header,
          message: message,
          buttons: [
            {
              text: this.$t("buttons.cancel"),
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
              text: buttonName,
              handler: async () => {
                if (type == 'post') {
                  //console.log('Confirm Delete ' + sliderImage.id)
                  await this.presentLoading(this.$t("loadmessage.updating"));
                  let response = await this.$store.dispatch("postedit/deletePost", {
                    id: this.imageId
                  });
                  if (response) {
                    if (response['error'] != null) {
                      this.error = response['error'];
                    } else {
                      this.loadingIndicator.dismiss();
                      //this.$emit('update:description', this.$store.state.postedit.caption);
                      //this.$store.commit('postedit/setCaption', '');
                      this.completedPost('delete', this.imageId);
                    }
                  } else {
                    this.loadingIndicator.dismiss();
                    this.error = "Unkown error";
                  }
                } else if (type == 'add') {
                  await this.presentLoading(this.$t("loadmessage.updating"));
                  let response = await this.$store.dispatch("postedit/requestToAdd", {
                    storyid: this.piklistId
                  });
                  if (response) {
                    if (response['error'] != null) {
                      this.error = response['error'];
                    } else {
                      this.loadingIndicator.dismiss();
                    }
                  } else {
                    this.loadingIndicator.dismiss();
                    this.error = "Unkown error";
                  }
                } else if (type == 'pin') {
                  await this.presentLoading(this.$t("loadmessage.updating"));
                  let response = await this.$store.dispatch("postedit/pinpost", {
                    postId: id
                  });
                  if (response) {
                    if (response['error'] != null) {
                      this.error = response['error'];
                    } else {
                      this.pinnedPostRefresh();
                      //this.completedPost('pin', id);
                    }
                  } else {
                    this.loadingIndicator.dismiss();
                    this.error = "Unkown error";
                  }
                } else if (type == 'unpin') {
                  await this.presentLoading(this.$t("loadmessage.updating"));
                  let response = await this.$store.dispatch("postedit/unpinpost", {
                    pinId: id
                  });
                  if (response) {
                    if (response['error'] != null) {
                      this.error = response['error'];
                    } else {
                      this.pinnedPostRefresh();
                      //this.completedPost('unpin', id);
                    }
                  } else {
                    this.loadingIndicator.dismiss();
                    this.error = "Unkown error";
                  }
                }
              },
            },
          ],
        });
      await alert.present();

    },
    async openEditStoryNameModal(story) {
      const modal = await modalController
        .create({
          component: EditStoryNameModal,
          cssClass: 'editstory-custom-class',
          componentProps: {
            title: this.$t("modalhead.editstoryname"),
            story: story,
          }
        })
      await modal.present();
      const dismissed = await modal.onDidDismiss();
      if (dismissed.role != 'canceled') {
        //this.displayPiklistName = this.$store.state.postedit.storyName;
        this.$emit('update:piklist_name', this.$store.state.postedit.storyName);
        //this.$store.commit('postedit/setStoryname', '');
        this.completedPost('storyname', story);
      }
    },
    async openEditCanAddModal(story) {
      const modal = await modalController
        .create({
          component: EditPrivacyModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: this.$t("modalhead.editcanadd"),
            type: 'canadd',
            story: story,
          }
        })
      return await modal.present();
    },
    async openEditPrivacyModal(story) {
      const modal = await modalController
        .create({
          component: EditPrivacyModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: this.$t("modalhead.editcanview"),
            type: 'canview',
            story: story
          }
        })
      await modal.present();
      const dismissed = await modal.onDidDismiss();
      if (dismissed.role != 'canceled') {
        //this.displayVisibility = this.$store.state.postedit.visibility;
        this.$emit('update:visibility', this.$store.state.postedit.visibility);
        //this.$store.commit('postedit/setVisibility', '');
        this.completedPost('visbility', story);
      }
    },
    async openReportPostModal() {
      const modal = await modalController
        .create({
          component: ReportPostModal,
          cssClass: 'modal-custom-class',
          componentProps: {
            title: this.$t("modalhead.report"),
            imageId: this.imageId,
            type: 2
          }
        })
      return await modal.present();
    },
    async openHidePostModal() {
      const modal = await modalController
        .create({
          component: HidePostModal,
          cssClass: 'hidepost-custom-class',
          componentProps: {
            title: this.$t("modalhead.hidepost"),
            imageId: this.imageId
          }
        })
      return await modal.present();
    },
    async presentLoginAlertConfirm() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: this.$t("alerthead.login"),
          message: this.$t("alertmessage.login", { app: getEnv('APP_NAME') }),
          buttons: [
            {
              text: this.$t("buttons.cancel"),
              role: 'cancel',
              cssClass: 'secondary',
            },
            {
              text: this.$t("buttons.loginsignup"),
              handler: () => {
                this.$router.push("/login");
              },
            },

          ],
        });
      return alert.present();
    },
    showVisibility(visibility) {
      var icon = globeOutline;
      if (visibility == 0 || visibility == 2) {
        icon = people
        /// icon = person;
      } else if (visibility == 1) {
        icon = globeOutline;
      } else if (visibility == 3) {
        icon = bookmarks;
      }
      return icon;
    },
    showAddedBy(user_name) {
      let addedCaption = '';
      if (user_name != '') {
        addedCaption = this.$t("buttons.addedby") + ' <strong>@' + user_name + '</strong>';
      }
      return addedCaption;
    },
    async presentLoading(message) {
      this.loadingIndicator = await loadingController
        .create({
          cssClass: 'loading-class',
          message: message,
        });
      await this.loadingIndicator.present();
    },
    async completedPost(type, data) {
      let streamName = '';
      let userid = '';
      let groupid = '';
      let caption = '';
      let visibility = '';
      let imageid = null;
      let story = null;
      let storyname = '';

      if (this.$route.name == "story") {
        if (type == 'delete') {
          let images = this.story.allimages;
          if (images.length == 1) {
            this.$router.replace({ name: 'home'});
          } else {
            for (let i = 0; i < images.length; i++) {
              if (images[i].id != data) {
                //console.log('found', images[i].id);
                imageid = images[i].id
              }
            }
            //console.log(this.$route.params.imageid);
            if(this.$route.params.imageid == imageid){
              console.log('its the same');
              this.$router.go();
            }else{
              this.$router.replace({ name: 'story', params: { imageid: imageid } });
            }
          }
          return;
        } else if (type == 'caption' || type == 'pin' || type == 'unpin') {
          imageid = data;
        } else if (type == 'storyname') {
          this.$store.commit('postedit/setStoryname', '');
          story = data.piklist_id;
          imageid = data.pik_id;
        } else if (type == 'visbility') {
          visibility = this.$store.state.postedit.visibility;
          story = data.piklist_id;
          imageid = data.pik_id;
        }
        
        this.presentLoading(this.$t("loadmessage.loading"));
        let response = await this.$store.dispatch("pikstream/getStream", {
          streamName: 'story',
          filter: null,
          imageid: imageid,
          storyid: story,
          total_list: 1,
          last_id: 0,
          userid: userid,
          groupid: groupid
        });
        if (response) {
          this.loadingIndicator.dismiss();
        }
      } else {
        if ((this.$route.name == "profile" && (this.$route.params.id == this.myProfileId))) {
          userid = parseInt(this.$route.params.id);
          streamName = 'myprofile';
        } else if (this.$route.name == "profile") {
          userid = parseInt(this.$route.params.id);
          streamName = 'profile';
        } else if (this.$route.name == "groupview") {
          groupid = this.$route.params.id;
          streamName = 'grouppage';
        } else if (this.$route.name == "home") {
          if (this.story.groupInfo['id'] != undefined) {
            streamName = 'groupfeed';
          }
        }

        if (type == 'caption') {
          caption = this.description;
          imageid = data;
        } else if (type == 'delete') {
          imageid = data;
        } else if (type == 'storyname') {
          storyname = this.$store.state.postedit.storyName;
          this.$store.commit('postedit/setStoryname', '');
          story = data;
        } else if (type == 'visbility') {
          visibility = this.$store.state.postedit.visibility;
          this.$store.commit('postedit/setVisibility', '');
          story = data;
        }

        this.$store.commit("pikstream/setEdit", {
          streamName: streamName,
          type: type,
          story: story,
          imageid: imageid,
          visibility: visibility,
          caption: caption,
          storyname: storyname,
          userid: userid,
          groupid: groupid
        });
      }
      /* if (this.streamName == "profile" || this.streamName == "ownerpreviewpremium") {
        userid = this.$route.params.id;
        this.$store.commit('pikstream/setProfileRequest', [[], userid]);
      } else if (this.streamName == "myprofile" || this.streamName == "premium" || this.streamName == "ownerpremium") {
        this.$store.commit('pikstream/setMyProfileRequest', null);
      } else if (this.streamName == "favorites") {
        this.$store.commit('pikstream/setFavoriteRequest', null);
      } else if (this.streamName == "home") {
        this.$store.commit('pikstream/setFollowRequest', null);
      } else if (this.streamName == "featured") {
        this.$store.commit('pikstream/setRecommendRequest', null);
      } else if (this.streamName == "elections") {
        this.$store.commit('pikstream/setElectionRequest', null);
      } else if (this.streamName == "grouppage") {
        groupid = this.$route.params.id;
        this.$store.commit('pikstream/setGroupFeedRequestNull');
        this.$store.commit('pikstream/setGroupRequestNull', groupid);
      } else if (this.streamName == "groupfeed") {
        this.$store.commit('pikstream/setGroupFeedRequestNull');
      } */

      /* let response = await this.$store.dispatch("pikstream/getStream", {
        streamName: streamName,
        filter: null,
        imageid: imageid,
        storyid: null,
        total_list: 7,
        last_id: 0,
        userid: userid,
        groupid: groupid
      }); 
      if (response) {
        this.loadingIndicator.dismiss();
      } */
    },
    async pinnedPostRefresh(){
      let streamName = '';
      let userid = '';
      let groupid = '';
      let imageid = null;
      
      if ((this.$route.name == "profile" && (this.$route.params.id == this.myProfileId))) {
        userid = parseInt(this.$route.params.id);
        streamName = 'myprofile';
      } else if (this.$route.name == "profile") {
        userid = parseInt(this.$route.params.id);
        streamName = 'profile';
      } else if (this.$route.name == "groupview") {
        groupid = this.$route.params.id;
        streamName = 'grouppage';
      } else if (this.$route.name == "home") {
        if (this.story.groupInfo['id'] != undefined) {
          streamName = 'groupfeed';
        }
      }

      let response = await this.$store.dispatch("pikstream/getStream", {
        streamName: streamName,
        filter: null,
        imageid: imageid,
        storyid: null,
        total_list: 7,
        last_id: 0,
        userid: userid,
        groupid: groupid
      }); 
      if (response) {
        this.loadingIndicator.dismiss();
      }
    },
    /* async completedPostOLD() {
      //console.log(this.$route.name);
      var streamName = '';
      var userid = '';
      var groupid = '';
      var imageid = null;
      this.presentLoading(this.$t("loadmessage.loading"));
      if (this.$route.name == "myprofile") {
        streamName = 'myprofile';
      } else if (this.$route.name == "profile") {
        streamName = 'profile';
        userid = this.$route.params.id;
      } else if (this.$route.name == "groupview") {
        streamName = 'grouppage';
        groupid = this.$route.params.id;
      } else if (this.$route.name == "feed") {
        if(this.story.groupInfo['id']!=undefined){
          streamName = 'groupfeed';
        }
      }

      let response = await this.$store.dispatch("pikstream/getStream", {
        streamName: streamName,
        filter: null,
        imageid: imageid,
        storyid: null,
        total_list: 7,
        last_id: 0,
        userid: userid,
        groupid: groupid
      });
      if (response) {
        this.loadingIndicator.dismiss();
      }
    },*/
    imgUrlAlt(event) {
      event.target.src = "/assets/spyguy.png";
    },
    localDate() {
      let dateChosen = this.date_time;
      if (this.repost == true) {
        dateChosen = this.origin_date;
      }
      return dateChosen;
    },
    async showRepostInfo() {
      //console.log('get the repost data');
      //console.log("pikstream/stream-image?id=" + this.piklistId + "&image_id=" + this.pikd_pik_id);
      if (this.pikd_pik_id != 0 && this.pikd_pik_id != null && this.repost == true && this.originator_id != 0) {
        let response = await this.$store.dispatch("pikstream/imageData", {
          url: "pikstream/stream-image?image_id=" + this.pikd_pik_id
        });
        if (response) {
          //console.log(response.full_name, 'get repost data');
          this.repost_username = response.user_name;
          this.originator_fullname = response.full_name;
          this.originator_profile_pic = response.profile_pic;
          this.originator_userbadge = response.userbadge;
          this.origin_date = response.date_time;
        }
      }
    }
  },
  watch: {
    originator_id() {
      this.showRepostInfo();
    },
  },
  computed: {
    premiereTime() {
      if (!this.premiere_date) return '';
      const now = dayjs();
      const premiere = dayjs(this.premiere_date);
      if (premiere.isAfter(now)) {
        return premiere.from(now); // e.g., "in 2 hours" or "in 3 days"
      }
      return 'now'; // If the premiere date is in the past or now
    },
  },
});
</script>